// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ReplicationDetailsQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type ReplicationDetailsQuery = {
  __typename?: "GraphqlQuery";
  getPostgresServerStats: Array<{
    __typename?: "PostgresServerStats";
    postgresServerStatsId: string;
    collectedAt: number;
    isPrimary: boolean;
    primaryWalLsn?: string | null;
    standbyIsStreaming?: boolean | null;
    standbyReceiveLsn?: string | null;
    standbyReplayLsn?: string | null;
    standbyApplyByteLag?: number | null;
    standbyReplayTimestamp?: number | null;
    standbyReplayTimestampAge?: number | null;
  }>;
  getReplicationFollowers: Array<{
    __typename?: "ReplicationFollower";
    id: string;
    clientAddr: string;
    syncState?: string | null;
    lastStats?: {
      __typename?: "ReplicationFollowerLastStats";
      collectedAt: number;
      state?: string | null;
      remoteByteLag?: number | null;
      localByteLag?: number | null;
      sentLsn?: string | null;
      writeLsn?: string | null;
      flushLsn?: string | null;
      replayLsn?: string | null;
    } | null;
  }>;
  getServerDetails: { __typename?: "Server"; id: string };
  getSystemDetails: {
    __typename?: "SystemDetails";
    info?: {
      __typename?: "SystemInfo";
      systemType?: string | null;
      data?: {
        __typename?: "SystemInfoData";
        isAuroraPostgres?: boolean | null;
      } | null;
    } | null;
  };
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    walSize?: Array<Array<number | null> | null> | null;
  } | null;
  getPostgresSettings: Array<{
    __typename?: "PostgresSetting";
    name: string;
    resetValue?: string | null;
  }>;
};

export const ReplicationDetailsDocument = gql`
  query ReplicationDetails($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getPostgresServerStats(
      serverId: $serverId
      startTs: $startTs
      endTs: $endTs
    ) {
      postgresServerStatsId
      collectedAt
      isPrimary
      primaryWalLsn
      standbyIsStreaming
      standbyReceiveLsn
      standbyReplayLsn
      standbyApplyByteLag
      standbyReplayTimestamp
      standbyReplayTimestampAge
    }
    getReplicationFollowers(
      serverId: $serverId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      clientAddr
      syncState
      lastStats {
        collectedAt
        state
        remoteByteLag
        localByteLag
        sentLsn
        writeLsn
        flushLsn
        replayLsn
      }
    }
    getServerDetails(serverId: $serverId) {
      id
    }
    getSystemDetails(serverId: $serverId) {
      info {
        systemType
        data {
          isAuroraPostgres
        }
      }
    }
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      walSize
    }
    getPostgresSettings(
      serverId: $serverId
      patterns: ["max_wal_size", "min_wal_size"]
    ) {
      name
      resetValue
    }
  }
`;

/**
 * __useReplicationDetailsQuery__
 *
 * To run a query within a React component, call `useReplicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplicationDetailsQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useReplicationDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReplicationDetailsQuery,
    ReplicationDetailsQueryVariables
  > &
    (
      | { variables: ReplicationDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReplicationDetailsQuery,
    ReplicationDetailsQueryVariables
  >(ReplicationDetailsDocument, options);
}
export function useReplicationDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReplicationDetailsQuery,
    ReplicationDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReplicationDetailsQuery,
    ReplicationDetailsQueryVariables
  >(ReplicationDetailsDocument, options);
}
// @ts-ignore
export function useReplicationDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReplicationDetailsQuery,
    ReplicationDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ReplicationDetailsQuery,
  ReplicationDetailsQueryVariables
>;
export function useReplicationDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReplicationDetailsQuery,
        ReplicationDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ReplicationDetailsQuery | undefined,
  ReplicationDetailsQueryVariables
>;
export function useReplicationDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReplicationDetailsQuery,
        ReplicationDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ReplicationDetailsQuery,
    ReplicationDetailsQueryVariables
  >(ReplicationDetailsDocument, options);
}
export type ReplicationDetailsQueryHookResult = ReturnType<
  typeof useReplicationDetailsQuery
>;
export type ReplicationDetailsLazyQueryHookResult = ReturnType<
  typeof useReplicationDetailsLazyQuery
>;
export type ReplicationDetailsSuspenseQueryHookResult = ReturnType<
  typeof useReplicationDetailsSuspenseQuery
>;
export type ReplicationDetailsQueryResult = Apollo.QueryResult<
  ReplicationDetailsQuery,
  ReplicationDetailsQueryVariables
>;
